import React from 'react'
import ContactPage from '../components/PrivacyPolicyComp/ContactPage'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

const PrivacyPolicy = () => {
  return (
    <div>
      <Navbar />
      <ContactPage />
      <Footer />
    </div>
  )
}

export default PrivacyPolicy
